import { produce, Draft } from 'immer'
import { IAction, TActionTypes } from '@Root/types'

import {
  IProjectVersionSettingsTtsState,
  TProjectVersionSettingsTtsActionTypes,
  ProjectVersionSettingsTtsActionTypes,
  IFetchProjectVersionSettingsTtsSuccessResponseBody,
  IProjectVersionSettingsTtsAttributes,
  IAvailableTtsLanguagesAttributes,
  ILastUsedSettingsTtsAttributes,
  IFetchTranslationLanguagesTtsSuccessResponseBody,
} from './types'

const initialSettings: IProjectVersionSettingsTtsAttributes = {
  language: '',
  subtitleLanguages: []
}

const initialAvailableLanguages: IAvailableTtsLanguagesAttributes = {
  dubbingLanguages: [],
  dubbingLanguagesTranslation: []
}

const initialLastUsedSettings: ILastUsedSettingsTtsAttributes = {
}

export const initialState: IProjectVersionSettingsTtsState = {
  settings: initialSettings,
  availableLanguages: initialAvailableLanguages,
  lastUsedSettings: initialLastUsedSettings,
  hasLoadedSuccessfully: false,
  fetchingTranslationLanguages: false,

}

type TAction = TActionTypes | TProjectVersionSettingsTtsActionTypes

export const projectVersionSettingsTtsReducer = (
  state: IProjectVersionSettingsTtsState = initialState,
  action: TAction,
): IProjectVersionSettingsTtsState => {
  return produce(state, draft => {
    switch (action.type) {
      case ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS:
        fetchProjectVersionSettingsTts(draft)
        break

      case ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS_SUCCESS:
        fetchProjectVersionSettingsTtsSuccess(draft, action)
        break

      case ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS_FAILURE:
        fetchProjectVersionSettingsTtsFailure(draft)
        break

      case ProjectVersionSettingsTtsActionTypes.RESET_PROJECT_VERSION_SETTINGS_TTS:
        resetProjectVersionSettingsTts(draft)
        break

      case ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS:
        fetchTranslationLanguagesTts(draft)
        break

      case ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS_SUCCESS:
        fetchTranslationLanguagesTtsSuccess(draft, action)
        break

      case ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS_FAILURE:
        fetchTranslationLanguagesTtsFailure(draft)
        break

      case ProjectVersionSettingsTtsActionTypes.RESET_TRANSLATION_LANGUAGES_TTS:
        resetTranslationLanguagesTts(draft)
        break

      default:
        break
    }
  })
}

const fetchProjectVersionSettingsTts = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.hasLoadedSuccessfully = false
}

function isFetchProjectVersionSettingsTtsSuccessAction(arg: any): arg is IAction<IFetchProjectVersionSettingsTtsSuccessResponseBody> {
  return arg.type === ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS_SUCCESS
}

const fetchProjectVersionSettingsTtsSuccess = (draft: Draft<IProjectVersionSettingsTtsState>, action: TAction) => {
  if (!isFetchProjectVersionSettingsTtsSuccessAction(action)) { return }

  if (action.payload.projectVersionSettings) {
    draft.settings = { ...initialSettings, ...action.payload.projectVersionSettings.attributes }
  }
  draft.availableLanguages = action.payload.availableLanguages.attributes
  draft.lastUsedSettings = action.payload.lastUsedSettings.attributes
  draft.hasLoadedSuccessfully = true
}

const fetchProjectVersionSettingsTtsFailure = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.hasLoadedSuccessfully = false
}

const resetProjectVersionSettingsTts = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.hasLoadedSuccessfully = false
  draft.settings = initialSettings
  draft.availableLanguages = initialAvailableLanguages
  draft.lastUsedSettings = initialLastUsedSettings
}

const fetchTranslationLanguagesTts = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.fetchingTranslationLanguages = true
}

function isIFetchTranslationLanguagesTtsSuccessAction(arg: any): arg is IAction<IFetchTranslationLanguagesTtsSuccessResponseBody> {
  return (
    arg.type === ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS_SUCCESS
  )
}

const fetchTranslationLanguagesTtsSuccess = (draft: Draft<IProjectVersionSettingsTtsState>, action: TAction) => {
  if (!isIFetchTranslationLanguagesTtsSuccessAction(action)) { return }

  draft.availableLanguages.dubbingLanguagesTranslation = action.payload.translationLanguages
  draft.fetchingTranslationLanguages = false
}

const fetchTranslationLanguagesTtsFailure = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.availableLanguages.dubbingLanguagesTranslation = []
  draft.fetchingTranslationLanguages = false
}

const resetTranslationLanguagesTts = (draft: Draft<IProjectVersionSettingsTtsState>) => {
  draft.availableLanguages.dubbingLanguagesTranslation = []
}
